var shopsInHighlightedBoundsFilter = function(storeServ) {

    return function(shops) {

        let highlightedBoundsLit = storeServ.getState().boundsToHighlight;
        
        if (boundsToHighlight) {

	        let highlightedBounds = new google.maps.LatLngBounds(
	            new google.maps.LatLng(highlightedBoundsLit.southWestLat, highlightedBoundsLit.southWestLng),
	            new google.maps.LatLng(highlightedBoundsLit.northEastLat, highlightedBoundsLit.northEastLng)
	        );
            
            return shops.filter((shop) => {
                let shopLocation = new google.maps.LatLng(shop.lat, shop.lng);
                return highlightedBounds.contains(shopLocation);
            });
        } else {
            return shops;
        }
    };
};

shopsInHighlightedBoundsFilter.$inject = ['storeServ'];

export default shopsInHighlightedBoundsFilter;